import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, useSearchParams } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { setCoachRef, trackEvent } from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Quiz from "@/pages/Quiz";
import About from "@/pages/About";
import Resources from "@/pages/Resources";
import Post from "@/pages/Post";
import Contact from "@/pages/Contact";
import { Privacy, Terms } from "@/pages/Legal";
import Result from "@/pages/Result";
import WelcomeBack from "@/pages/WelcomeBack";
import Success from "@/pages/Success";
import Members from "@/pages/Members";
import Redeem from "@/pages/Redeem";
import Coaches from "@/pages/Coaches";
import Women from "@/pages/Women";
import Admin from "@/pages/Admin";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const CoachRefCapture = () => {
  const [params] = useSearchParams();
  useEffect(() => {
    const coach = params.get("coach");
    if (coach) {
      setCoachRef(coach);
      trackEvent("coach_ref_captured", { coach });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
};

const SmoothScroll = ({ children }) => {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
  return children;
};

function App() {
  return (
    <div className="App noise-overlay bg-obsidian min-h-screen">
      <SmoothScroll>
        <BrowserRouter>
          <ScrollToTop />
          <CoachRefCapture />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/about" element={<About />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/resources/:slug" element={<Post />} />
            <Route path="/result/:id" element={<Result />} />
            <Route path="/welcome-back" element={<WelcomeBack />} />
            <Route path="/success" element={<Success />} />
            <Route path="/members" element={<Members />} />
            <Route path="/redeem" element={<Redeem />} />
            <Route path="/coaches" element={<Coaches />} />
            <Route path="/women" element={<Women />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <Footer />
          <Toaster theme="dark" />
        </BrowserRouter>
      </SmoothScroll>
    </div>
  );
}

export default App;
